import { createAction } from 'redux-actions';
import { http } from 'helpers/axios';
import assign from 'lodash/assign';
import cloneDeep from 'lodash/cloneDeep';
import download from 'downloadjs';

export const loading = createAction('@@cms/loading');

export const fetchCampaign = createAction(
  '@@cms/fetchCampaign',
  id => dispatch => {
    dispatch(loading());
    return http.get(`/campaigns/${id}`).get('data');
  }
);

export const fetchEncodings = createAction(
  '@@cms/fetchEncodings',
  campaignId => dispatch => {
    dispatch(loading());
    return http
      .get(
        `/encodings?query={"campaign":"${campaignId}"}&populate=tones,file&pageSize=1000`
      )
      .get('data')
      .then(({ docs }) => {
        return docs;
      });
  }
);

export const createEncoding = createAction(
  '@@cms/createEncoding',
  (campaignId, file) => dispatch => {
    dispatch(loading());

    return http
      .post('/encodings', {
        campaign: campaignId,
        file: file._id,
        status: 'new',
      })
      .get('data')
      .then(data => assign(data, { file }));
  }
);

export const downloadMedia = createAction(
  '@@cms/downloadMedia',
  encoding => dispatch => {
    dispatch(loading());

    const file = encoding.file;
    // return encoding;
    return http
      .get('/files/download', {
        params: {
          container: file.container,
          blob: file.blob,
          fileName: file.fileName,
        },
        responseType: 'arraybuffer',
      })
      .then(res => {
        download(res.data, file.fileName, res.headers['content-type']);
      });
  }
);

export const encode = createAction('@@cms/encode', encoding => dispatch => {
  dispatch(loading());

  let copyEncode = JSON.parse(JSON.stringify(encoding));

  copyEncode.status = 'processing';
  console.log('encode action');

  // return encoding;
  return http.post('/encode', copyEncode).then(({ data }) => {
    return data;
  });
});

export const addTone = createAction('@@cms/addTone', encoding => dispatch => {
  dispatch(loading());
  // Please check o smt-server/.../models/Tone.js for further information
  const payload = {
    encodingId: encoding._id,
    campaign: encoding.campaign,
    type: 1,
    leftOffset: 0,
    rightOffset: 0,
    time: 0,
    throught: false,
  };

  return http
    .post('/tones', payload)
    .get('data')
    .catch(err => {
      console.error('ERROR', err);
    });
});

export const updateTone = createAction('@@cms/updateTone', tone => dispatch => {
  dispatch(loading());
  let copyTone = JSON.parse(JSON.stringify(tone));
  delete copyTone._id;
  delete copyTone.__v;

  if (
    copyTone.hasOwnProperty('experience') &&
    typeof copyTone.experience === 'object'
  ) {
    copyTone.experience = copyTone.experience._id;
  }

  return http.put(`/tones/${tone._id}`, copyTone).then(({ data }) => {
    // The endpoint is not returning the full file object,
    // so we have to reuse the file passed by param.
    return data;
  });
});

export const deleteTone = createAction(
  '@@cms/deleteTone',
  (encoding, tone) => dispatch => {
    dispatch(loading());

    const newEncoding = cloneDeep(encoding);
    return http
      .delete(`/tones/${newEncoding._id}/${tone._id}`)
      .then(({ data }) => {
        // The endpoint is not returning the full file object,
        // so we have to reuse the file passed by param.
        return assign(data, { file: newEncoding.file });
      });
  }
);

export const fetchExperiences = createAction(
  '@@cms/fetchExperiences',
  campaignId => dispatch => {
    dispatch(loading());
    return http
      .get(`/experiences?query={"campaign":"${campaignId}"}&pageSize=1000`)
      .get('data');
  }
);

export const deleteEncoding = createAction(
  '@@cms/deleteEncoding',
  encodingId => dispatch => {
    dispatch(loading());
    return http.delete(`/encodings/${encodingId}`).get('data');
  }
);

export const selectEncoding = createAction('@@cms/selectEncoding');

export const clearCms = createAction('@@cms/clearCms');
